@let premiseControls = form().controls.premises.controls;
@let appMode = appMode$ | async;
@let editingOrAdding = appMode === 'add' || appMode === 'edit';

<form [formGroup]="form()">
    <fieldset>
        <legend
            class="form-label h6 fw-bold d-flex align-items-center justify-content-between"
        >
            <span i18n>Premises</span>
            @if (editingOrAdding) {
            <la-icon-button
                [icon]="faPlus"
                iconPosition="right"
                size="sm"
                label="Add premise"
                (click)="addPremise()"
                i18n-label
                outline
            />
            }
        </legend>

        <ul class="ps-0 list-unstyled" formArrayName="premises">
            @for (control of premiseControls; let i = $index; track
            `${i}-${control.value}`) {
            <li class="mb-3">
                <div class="input-group">
                    <input
                        [id]="'premise-' + i"
                        type="text"
                        [class]="
                            editingOrAdding
                                ? 'form-control'
                                : 'form-control-plaintext'
                        "
                        [formControlName]="i"
                    />
                    @if (editingOrAdding) {
                    <la-icon-button
                        buttonStyle="danger"
                        [icon]="faTrash"
                        label="Remove"
                        (click)="removePremise(i)"
                        visuallyHiddenLabel
                        i18n-label
                    />
                    }
                </div>
            </li>
            } @empty {
            <li class="text-muted" i18n>
                No premises defined for this problem.
            </li>
            }
        </ul>
    </fieldset>

    <div class="mb-3">
        <label for="hypothesis" class="form-label fw-bold" i18n>
            Hypothesis
        </label>
        <input
            id="hypothesis"
            type="text"
            [class]="
                editingOrAdding ? 'form-control' : 'form-control-plaintext'
            "
            [class.is-invalid]="
                form().controls.hypothesis.touched &&
                form().controls.hypothesis.invalid
            "
            [formControl]="form().controls.hypothesis"
        />
        <p class="invalid-feedback" i18n>
            Each problem must have a hypothesis.
        </p>
    </div>
</form>
